import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "drawer__wraper"
}
const _hoisted_2 = {
  key: 0,
  class: "pick-up-location"
}
const _hoisted_3 = { class: "pick-up-location__actions" }
const _hoisted_4 = { class: "pick-up-location__types" }
const _hoisted_5 = { class: "pick-up-location__address" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"pick-up-location__pointer\"><svg width=\"44\" height=\"76\" viewBox=\"0 0 44 76\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"20\" y=\"41\" width=\"4\" height=\"32\" rx=\"2\" fill=\"#0B4622\"></rect><circle cx=\"22\" cy=\"22\" r=\"22\" fill=\"#0B4622\"></circle><circle cx=\"22\" cy=\"22\" r=\"8\" fill=\"white\"></circle></svg></div>", 1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 1,
  class: "pick-up-location"
}
const _hoisted_9 = { class: "pick-up-location__actions" }
const _hoisted_10 = { class: "pick-up-location__types" }
const _hoisted_11 = { class: "pick-up-location__address" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YandexMap = _resolveComponent("YandexMap")!
  const _component_AAutocomplete = _resolveComponent("AAutocomplete")!
  const _component_YandexMarker = _resolveComponent("YandexMarker")!
  const _component_YandexClusterer = _resolveComponent("YandexClusterer")!

  return (_ctx.isInit)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.currentDeliveryType == 'delivery')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_YandexMap, {
                events: [
          'actionend',
          'actionbegin',
          'mousedown',
          'pointerdown',
          'mouseup',
          'pointerup',
        ],
                settings: _ctx.settings,
                coordinates: _ctx.centerCoordinate,
                zoom: 17,
                "detailed-controls": [],
                controls: ['zoomControl'],
                onActionend: _ctx.actionend,
                onActionbegin: _ctx.actionbegin,
                onMousedown: _ctx.mapDown,
                onPointerdown: _ctx.mapDown,
                onMouseup: _ctx.mapUp,
                onPointerup: _ctx.mapUp
              }, null, 8, ["settings", "coordinates", "onActionend", "onActionbegin", "onMousedown", "onPointerdown", "onMouseup", "onPointerup"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["card__btn", { 'card_btn-dark': _ctx.currentDeliveryType != 'delivery' }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentDeliveryType = 'delivery'))
                  }, " Доставка ", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["card__btn", { 'card_btn-dark': _ctx.currentDeliveryType != 'pickup' }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentDeliveryType = 'pickup'))
                  }, " Самовывоз ", 2)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_AAutocomplete, {
                    modelValue: _ctx.location,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.location) = $event)),
                    label: "address",
                    source: _ctx.getSuggestionsAddress,
                    onChange: _ctx.changeLocation,
                    style: {"z-index":"2"}
                  }, null, 8, ["modelValue", "source", "onChange"])
                ])
              ]),
              _hoisted_6,
              _createElementVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitDelivery($event)), ["prevent"])),
                class: "pick-up-location__bottom-actions"
              }, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "card__btn",
                  disabled: _ctx.location == null || _ctx.disableBtn
                }, " Подтвердить адрес ", 8, _hoisted_7)
              ], 32)
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentDeliveryType == 'pickup')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_YandexMap, {
                ref: "map",
                events: [],
                settings: _ctx.settings,
                coordinates: _ctx.centerCoordinate,
                zoom: 12,
                "detailed-controls": [],
                controls: ['zoomControl']
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_YandexClusterer, {
                    options: {
            clusterIcons: [
              {
                href: require('@/assets/img/cluster_custom.svg'),
                size: [46, 46],
                offset: [-20, -20],
              },
            ],
            preset: 'islands#darkgreenClusterIcons',
          }
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storesList, (item, key) => {
                        return (_openBlock(), _createBlock(_component_YandexMarker, {
                          ref_for: true,
                          ref: "yMarketPickup",
                          key: key,
                          coordinates: _ctx.test(item.COORDINATE),
                          "marker-id": key,
                          onClick: _ctx.selectPickup,
                          properties: {
              item: item,
            },
                          options: {
              iconLayout: 'default#image',
              iconImageHref:
                _ctx.selectedPickup?.ID == item.ID
                  ? require('@/assets/img/pin.svg')
                  : require('@/assets/img/map_baloon.svg'),
              iconImageSize: [30, 44],
              iconImageOffset: [-15, -44],
              preset: 'islands#greenDotIconWithCaption',
            }
                        }, null, 8, ["coordinates", "marker-id", "onClick", "properties", "options"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["options"])
                ]),
                _: 1
              }, 8, ["settings", "coordinates"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["card__btn", { 'card_btn-dark': _ctx.currentDeliveryType != 'delivery' }]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentDeliveryType = 'delivery'))
                  }, " Доставка ", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["card__btn", { 'card_btn-dark': _ctx.currentDeliveryType != 'pickup' }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentDeliveryType = 'pickup'))
                  }, " Самовывоз ", 2)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("input", {
                    type: "text",
                    placeholder: "Адрес пункта выдачи",
                    value: _ctx.addressPickup,
                    disabled: ""
                  }, null, 8, _hoisted_12)
                ])
              ]),
              _createElementVNode("form", {
                onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submitPickup($event)), ["prevent"])),
                class: "pick-up-location__bottom-actions"
              }, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "card__btn",
                  disabled: _ctx.selectedPickup == null || _ctx.disableBtn
                }, " Подтвердить адрес ", 8, _hoisted_13)
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}